<style lang="scss" scoped>
.tooltip {
    position: relative;
    width: 30px;
    line-height: 1.6;
    background: var(--gray-light);
    border: 1px solid var(--gray-light);
    border-radius: 3px;
    cursor: pointer;
    transition: border 0.2s;
    &:hover {
        border: 1px solid var(--gray);
    }
    .tooltip-popover {
        position: absolute;
        top: 17px;
        left: -110px;
        width: 250px;
        padding: 15px;
        background: #fff;
        border-radius: 3px;
        border: 1px solid var(--border-color);
        z-index: 10;
        font-size: 14px;
        .pie-chart {
            width: 25px;
            height: 25px;
            background-color: #f2f2f2;
            border-radius: 50%;
            margin: auto 16px auto 0;
            position: relative;
            display: flex;
            &:before {
                content: "";
                width: 3px;
                height: 100%;
                background: #fff;
                position: absolute;
                margin: 0 auto;
                left: 0;
                right: 0;
            }
        }
    }
}
</style>

<template>
    <div class="tooltip" @click="open = !open" v-click-outside="() => { open = false }">
        Ja
        <div v-if="open" class="tooltip-popover">
            <div v-for="(med,index) in medication" :key="index" class="d-flex text-left mb-8">
                <span class="pie-chart" :style="{ 'background-image': `conic-gradient(var(--primary) ${getConicPercentage(med.amount)}%, #f2f2f2 ${getConicPercentage(med.amount)}% )` }"></span>
                <p class="my-auto">[{{ med.amount }}] - {{ med.name }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'

export default {

    props: {
        medication: {
            required: false
        }
    },

    data() {
        return {
            open: false
        }
    },

    methods: {
        getConicPercentage(a) {
            switch (a) {
                case '1/16':
                    return (1 / 16) * 100
                case '1/8':
                    return (1 / 8) * 100
                case '1/4':
                    return (1 / 4) * 100
                case '1/2':
                    return (1 / 2) * 100
                case '3/4':
                    return (3 / 4) * 100
                case '1':
                case '>1':
                    return 100
                default:
                    return 0
            }
        }
    },

    directives: {
        ClickOutside
    }

}
</script>